import React from 'react'
import { Box, Typography } from '@mui/material'
import { INTERAX_COLORS, INTERAX_TYPOGRAPHY } from '../../../constants/colors'

export function splitProfileName(profileName: string): { firstWord: string; rest: string } {
  const words = profileName.trim().split(/\s+/)
  if (words.length === 0) {
    return { firstWord: '', rest: '' }
  }
  if (words.length === 1) {
    return { firstWord: words[0], rest: '' }
  }
  return {
    firstWord: words[0],
    rest: words.slice(1).join(' ')
  }
}

export interface ProfileSplitTitleProps {
  profileName: string
}

/**
 * Profile title: first word solid white, remainder golden gradient (existing gamer feedback pattern).
 */
export const ProfileSplitTitle: React.FC<ProfileSplitTitleProps> = ({ profileName }) => {
  const { firstWord, rest } = splitProfileName(profileName)

  const titleSx = {
    ...INTERAX_TYPOGRAPHY.headline3,
    fontWeight: 600,
    fontSize: { xs: '22px', sm: '24px', md: '26px' },
    lineHeight: { xs: '28px', sm: '32px', md: '34px' },
    margin: 0,
    overflowWrap: 'break-word' as const,
    minWidth: 0
  }

  return (
    <Box
      sx={{
        boxSizing: 'border-box',
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        gap: { xs: 0.5, sm: 1, md: 1 },
        minWidth: 0
      }}
    >
      {firstWord ? <Typography sx={{ ...titleSx, color: INTERAX_COLORS.white }}>{firstWord}</Typography> : null}
      {rest ? (
        <Typography
          sx={{
            ...titleSx,
            background: INTERAX_COLORS.gradientGoldenTitle,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            textShadow: `0px 0px 10px rgba(0, 0, 0, 0.5), 0px 0px 20px ${INTERAX_COLORS.sun40}`
          }}
        >
          {rest}
        </Typography>
      ) : null}
    </Box>
  )
}
